export const LOGIN_PARTICIPANT_USER = "LOGIN_PARTICIPANT_USER"
export const LOGIN_PARTICIPANT_SUCCESS = "LOGIN_PARTICIPANT_SUCCESS"

export const LOGOUT_PARTICIPANT_USER = "LOGOUT_PARTICIPANT_USER"
export const LOGOUT_PARTICIPANT_USER_SUCCESS = "LOGOUT_PARTICIPANT_USER_SUCCESS"
export const PARTICIPANT_LOGIN_ERROR = "PARTICIPANT_LOGIN_ERROR"
